
import { 
  Plane
} from "lucide-react";
import type { MenuItem } from "../types";

export const flightSection: MenuItem = {
  title: "الرحلات الجوية",
  href: "#",
  icon: Plane,
  color: "from-sky-500 to-sky-600",
  subItems: [
    {
      title: "شركات الطيران",
      href: "/airlines",
      icon: Plane,
      color: "from-sky-500 to-sky-600",
    },
    {
      title: "المطارات",
      href: "/airports",
      icon: Plane,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "إدارة الرحلات",
      href: "/flights",
      icon: Plane,
      color: "from-purple-500 to-purple-600",
    }
  ]
};
